import { Operator } from '../../../../../../../../services/common/Constants';
import EqualValue from './EqualValue';
import ContainsValue from './ContainsValue';
import SetValue from './SetValue';
import React from 'react';

const StringType = ({
  selectedOperator,
  fieldName,
  showLabel,
  availableValueOptions,
}) => {

  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
        />
      );
    case Operator.CONTAINS:
    case Operator.NOT_CONTAINS:
    case Operator.STARTS_WITH:
    case Operator.NOT_STARTS_WITH:
    case Operator.ENDS_WITH:
    case Operator.NOT_ENDS_WITH:
      return <ContainsValue fieldName={fieldName} showLabel={showLabel} />;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <></>;
    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return (
        <SetValue
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
        />
      );
    default:
      return <></>;
  }
};

export default StringType;
